/** Case-insensitive substring test used by the client-side search box. */
export function matches(haystack: string, needle: string): boolean {
  return haystack.toLowerCase().includes(needle);
}

/** Initials fallback for a source avatar when the feed has no logo. */
export function initials(title: string): string {
  const words = title
    .split(/[^\w#]+/)
    // Drop filler words and bare punctuation ("Tezos @ Youtube" -> "TY").
    .filter((word) => /[a-z0-9]/i.test(word) && !/^(the|at|of|and)$/i.test(word));
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** Deterministic hue per source so avatars stay stable across renders. */
export function hueFor(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 360;
  }
  return hash;
}
